var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3033 2.69674L12.125 3.87508C11.1708 2.92074 9.91514 2.3268 8.57208 2.19444C7.22902 2.06209 5.88162 2.39952 4.75945 3.14923C3.63728 3.89895 2.80978 5.01457 2.41795 6.306C2.02612 7.59743 2.09419 8.98477 2.61057 10.2316C3.12695 11.4785 4.05969 12.5078 5.24986 13.144C6.44003 13.7803 7.81399 13.9842 9.13765 13.721C10.4613 13.4578 11.6527 12.7438 12.509 11.7006C13.3652 10.6574 13.8332 9.34964 13.8333 8.00008H15.5C15.5 9.73524 14.8983 11.4167 13.7975 12.758C12.6968 14.0993 11.1649 15.0174 9.46312 15.3559C7.76129 15.6944 5.99475 15.4324 4.46448 14.6144C2.9342 13.7964 1.73489 12.4732 1.07088 10.8701C0.406878 9.267 0.319262 7.48327 0.822965 5.82283C1.32667 4.16238 2.39053 2.72796 3.83327 1.76396C5.27601 0.799966 7.00837 0.366044 8.73518 0.536131C10.462 0.706218 12.0764 1.46979 13.3033 2.69674Z",
    fill: "#2B8C34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.b2cb6c0269a2bd83cdadd225feb78163.svg";
export { ForwardRef as ReactComponent };